import { graphql, useStaticQuery } from "gatsby";
import React from "react";

import useLiveData from "hooks/useLiveData";

const InnerPageNav = props => {

    const { uri, items } = props;
    let menuNav = [];

    const data = useStaticQuery(graphql`
        {
          allContentMenu(
                filter: {approved: {eq: true}, archived: {eq: false}, deleted: {eq: false}}
        ) {
            edges {
                    node {
                        name
                        pages
                    }
                }
            }
        }
    `);

    const menus = data.allContentMenu.edges.map(({ node }) => node).filter(menu => menu.name === uri);

    const {
        statusText: menuProviderStatusText,
        response: menuProviderResponse,
    } = useLiveData({
        type: 'ContentMenu',
        apiParams: { name: uri },
        staticData: data,
    });

    let menu = menus[0];
    if ((menuProviderResponse.data.length > 0 || !!menus !== false) && menuProviderStatusText === 'LOADED') {
        menu = menuProviderResponse.data[0];
    }
    // if menu found add it to the page object as pageNav
    menuNav = !!menu ? menu.pages.map(nav => ({ name: nav.text, id: nav.href, target: nav.target })) : items;

    if (!menuNav?.length) {
        return null;
    }

    return (
        <nav id="page-nav">
            <div className="grid-container">
                <div className="grid-padding-x grid-x">
                    <div className="cell">
                        <ul className="menu">
                            {menuNav.map(nav => (
                                <li key={`page-nav-${nav.id}`}><a href={`${nav.id}`}>{nav.name}</a></li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default InnerPageNav;
